export const topicComments = {
  "variety-stage-rule-change": [
    { id: "c1", user: "戴耳机的阿哲", time: "2 小时前", content: "流动席位这个设计我觉得挺聪明的，至少减少了固定观众的口味惯性。", likes: 1286 },
    { id: "c2", user: "周末不加班", time: "3 小时前", content: "线上投票那两成真的不会被组织刷吗？这点还是有点担心。", likes: 942 },
    { id: "c3", user: "舞台边上", time: "5 小时前", content: "反正这两期的舞台质量肉眼可见地好了，赛制怎么改先看效果吧。", likes: 758 },
    { id: "c4", user: "一颗柠檬", time: "6 小时前", content: "支持拆分打分权，单一评审团真的太容易翻车了。", likes: 634 },
    { id: "c5", user: "路过看看", time: "8 小时前", content: "中立说一句：不管赛制如何，最后还是要舞台说话。", likes: 421 },
  ],
  "drama-long-street-lights-ending": [
    { id: "c1", user: "追到大结局", time: "1 小时前", content: "长镜头那一段我反复看了三遍，真的越想越有味道。", likes: 2140 },
    { id: "c2", user: "要闭环的观众", time: "2 小时前", content: "理解留白的用意，但关键转折没交代，情绪确实接不上。", likes: 1760 },
    { id: "c3", user: "剧评打工人", time: "4 小时前", content: "争议恰恰说明人物写得好，不然没人会为结局吵架。", likes: 1320 },
    { id: "c4", user: "沙发土豆", time: "7 小时前", content: "希望官方出个幕后解说，把创作思路讲清楚。", likes: 890 },
    { id: "c5", user: "深夜追剧", time: "9 小时前", content: "两条线我都能接受，但更喜欢留白那版。", likes: 505 },
  ],
  "music-festival-venue-change": [
    { id: "c1", user: "从外地赶来的", time: "1 小时前", content: "改签的钱自己出，希望主办方给个统一说明，别让大家各自猜。", likes: 1580 },
    { id: "c2", user: "安全第一", time: "3 小时前", content: "天气预警这种事没人能提前预判，换室内我完全能理解。", likes: 1240 },
    { id: "c3", user: "露天派", time: "5 小时前", content: "室内确实方便，但音乐节少了露天的氛围还是遗憾。", likes: 876 },
    { id: "c4", user: "已经到场", time: "6 小时前", content: "现场其实不错，动线比想象中顺畅，没大家说的那么糟。", likes: 642 },
  ],
  "creator-mountain-food-return": [
    { id: "c1", user: "安静看内容", time: "2 小时前", content: "这种不解释太多的回归方式，反而让我更愿意继续看。", likes: 980 },
    { id: "c2", user: "想要个说明", time: "4 小时前", content: "不是要八卦，就是觉得长期观众值得一句交代。", likes: 720 },
    { id: "c3", user: "慢生活爱好者", time: "6 小时前", content: "新一期节奏更慢，我特别喜欢，配乐压得刚刚好。", likes: 560 },
    { id: "c4", user: "路过点赞", time: "10 小时前", content: "内容做得好就是最好的解释，期待更新节奏稳定下来。", likes: 388 },
  ],
  "backstage-costume-reveal": [
    { id: "c1", user: "考据爱好者", time: "3 小时前", content: "纹样那块其实有依据，别急着下结论，路透角度也会误导人。", likes: 1120 },
    { id: "c2", user: "谨慎吃瓜", time: "5 小时前", content: "试装和成片差别很大的，等正片出来再评价比较公平。", likes: 940 },
    { id: "c3", user: "服化道观察", time: "7 小时前", content: "材质在灯光下确实会变色，单看路透判断还原度不太靠谱。", likes: 610 },
    { id: "c4", user: "爱科普", time: "11 小时前", content: "借这个机会了解了不少服饰知识，吵架之外也有收获。", likes: 402 },
  ],
  "variety-guest-wishlist": [
    { id: "c1", user: "心愿单填满", time: "1 小时前", content: "希望名单是真的，但更希望别给嘉宾添压力，轻松一点最好。", likes: 860 },
    { id: "c2", user: "综艺前瞻", time: "3 小时前", content: "每年这个时候都这样，猜得比节目还热闹，挺可爱的。", likes: 690 },
    { id: "c3", user: "理性围观", time: "6 小时前", content: "提醒一句，没官宣的都只是猜测，别当成事实传。", likes: 520 },
    { id: "c4", user: "观众席第一排", time: "9 小时前", content: "不管谁来，只要节目好玩就行，这才是重点。", likes: 315 },
  ],
  "music-band-tour-tickets": [
    { id: "c1", user: "拒绝加价", time: "2 小时前", content: "宁愿等下一场也不买加价票，大家一起抵制才有用。", likes: 1980 },
    { id: "c2", user: "行程已定", time: "4 小时前", content: "机票酒店都订好了，真的很难不妥协，理解双方的难处。", likes: 1240 },
    { id: "c3", user: "希望加场", time: "6 小时前", content: "与其争论谁对谁错，不如一起呼吁加场和实名制。", likes: 1060 },
    { id: "c4", user: "抢到票了", time: "8 小时前", content: "手速确实可以抢到，别只盯着二手平台。", likes: 540 },
  ],
  "drama-yearly-rating-board": [
    { id: "c1", user: "看剧口味独特", time: "2 小时前", content: "加权口径不透明的话，榜单说服力确实有限。", likes: 1320 },
    { id: "c2", user: "完播率党", time: "5 小时前", content: "完播率纳入统计我觉得挺合理，追完才算真的喜欢。", likes: 980 },
    { id: "c3", user: "一人一票", time: "7 小时前", content: "说到底还是审美差异，榜单看看就好，别太当真。", likes: 760 },
    { id: "c4", user: "剧荒中", time: "10 小时前", content: "不管排第几，我照着榜单补了几部，都还挺好看。", likes: 430 },
  ],
  "industry-actor-behind-camera": [
    { id: "c1", user: "从业者路人", time: "3 小时前", content: "转型幕后需要长期积累，愿意尝试就值得给点耐心。", likes: 720 },
    { id: "c2", user: "观望中", time: "6 小时前", content: "等成片吧，现在讨论早了点，信息还不够。", likes: 560 },
    { id: "c3", user: "期待新题材", time: "9 小时前", content: "希望新的视角能带来不一样的题材，别又是老套路。", likes: 410 },
    { id: "c4", user: "吃瓜保持距离", time: "12 小时前", content: "就事论事挺好，别把猜测当成已经确定的事情。", likes: 288 },
  ],
};

export const defaultComments = [
  { id: "d1", user: "热心网友", time: "1 小时前", content: "这个话题还在持续更新，有新进展记得回来看看。", likes: 210 },
  { id: "d2", user: "评论区常客", time: "4 小时前", content: "多方观点都列出来了，读起来比只刷一条动态清楚多了。", likes: 168 },
  { id: "d3", user: "路过留名", time: "8 小时前", content: "先收藏，等后续进展再回来补充看法。", likes: 96 },
];